import React from 'react';
import { AlertCircle } from 'lucide-react';

const DifficultyTab = ({ analysis }) => {
    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Analisi Competitività SERP</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg border-l-4 border-blue-500">
                    <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-semibold text-gray-700">SERP Difficulty</span>
                        <span className={`text-3xl font-bold ${analysis.serpDifficulty.score <= 3 ? 'text-green-600' :
                            analysis.serpDifficulty.score <= 6 ? 'text-yellow-600' :
                                'text-red-600'
                            }`}>
                            {analysis.serpDifficulty.score}/10
                        </span>
                    </div>
                    <div className="text-xs text-gray-600">
                        {analysis.serpDifficulty.score <= 3 && 'Bassa competitività - Buone opportunità'}
                        {analysis.serpDifficulty.score > 3 && analysis.serpDifficulty.score <= 6 && 'Media competitività - Richiede contenuto di qualità'}
                        {analysis.serpDifficulty.score > 6 && 'Alta competitività - SERP dominata da features'}
                    </div>
                </div>

                <div className="p-4 bg-gradient-to-br from-green-50 to-green-100 rounded-lg border-l-4 border-green-500">
                    <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-semibold text-gray-700">Spazio Organico</span>
                        <span className="text-3xl font-bold text-green-600">
                            {analysis.serpDifficulty.organicPercentage}%
                        </span>
                    </div>
                    <div className="text-xs text-gray-600">
                        {analysis.organicCount} risultati organici su {analysis.totalResults} totali
                    </div>
                </div>

                <div className="p-4 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg border-l-4 border-purple-500">
                    <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-semibold text-gray-700">Primo Risultato Organico</span>
                        <span className="text-3xl font-bold text-purple-600">
                            #{analysis.serpDifficulty.firstOrganicPosition}
                        </span>
                    </div>
                    <div className="text-xs text-gray-600">
                        Posizione nella SERP
                    </div>
                </div>

                <div className="p-4 bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg border-l-4 border-orange-500">
                    <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-semibold text-gray-700">Tipo di SERP</span>
                        <span className="text-lg font-bold text-orange-600">
                            {analysis.serpDifficulty.isCommercial ? 'Commerciale' : 'Informativa'}
                        </span>
                    </div>
                    <div className="text-xs text-gray-600">
                        {analysis.serpDifficulty.isCommercial ? 'Intento transazionale' : 'Intento informativo'}
                    </div>
                </div>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h3 className="font-semibold mb-3 flex items-center gap-2">
                    <AlertCircle size={18} className="text-blue-500" />
                    SERP Features Presenti ({analysis.serpDifficulty.features.length})
                </h3>
                <div className="flex flex-wrap gap-2">
                    {analysis.serpDifficulty.features.map((feature, i) => (
                        <span key={i} className="bg-white px-3 py-1 rounded border text-sm">
                            {feature}
                        </span>
                    ))}
                </div>
            </div>

            <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Interpretazione</h3>
                <ul className="text-sm space-y-2 text-gray-700">
                    <li>• <strong>Difficulty Score:</strong> Basato su numero di features competitive, posizione primo organico e saturazione SERP</li>
                    <li>• <strong>Spazio Organico:</strong> Percentuale di risultati organici rispetto al totale - più è alto, meglio è</li>
                    <li>• <strong>Features:</strong> Ogni feature compete per l'attenzione e riduce i click sui risultati organici</li>
                    {analysis.serpDifficulty.isCommercial && (
                        <li>• <strong>SERP Commerciale:</strong> Presenza di shopping results indica intento transazionale forte</li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default DifficultyTab;
